// JSON fetch helpers for the Promo Image Generator.
// Rails CSRF token is read from the meta tag injected by `csrf_meta_tags`.

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

async function request(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...(options.headers || {}),
    },
    ...options,
  });
  if (res.status === 204) return null;
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = body.errors ? body.errors.join(', ') : `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return body;
}

export const listTemplates = () => request('/admin/promo_image_templates/list');
export const loadTemplate = (id) => request(`/admin/promo_image_templates/${id}`);
export const createTemplate = (data) => request('/admin/promo_image_templates', { method: 'POST', body: JSON.stringify(data) });
export const updateTemplate = (id, data) => request(`/admin/promo_image_templates/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const deleteTemplate = (id) => request(`/admin/promo_image_templates/${id}`, { method: 'DELETE' });

export async function uploadBackground(templateId, frameId, file) {
  const form = new FormData();
  form.append('background', file);
  const res = await fetch(`/admin/promo_image_templates/${templateId}/frames/${frameId}/background`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': csrfToken(), Accept: 'application/json' },
    body: form,
  });
  if (!res.ok) throw new Error(`Background upload failed (${res.status})`);
  return res.json();
}
